<template>
  <a
    :key="id"
    class="UniverseCard"
  >
    <img class="UniverseCard__illustration" :src="picture.thumb" :alt="name" />
    <h4 class="UniverseCard__title">{{ name }}</h4>
  </a>
</template>
<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    picture: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.UniverseCard {
  display: block;
  margin-bottom: $global-margin/2;
  overflow: hidden;
  transition: all 0.16s;

  &__illustration {
    display: block;
    width: 100%;
    transform-origin: bottom;
    transition-duration: 1s;
  }

  &__title {
    margin: 0.5em 0;
    color: $color-black;
    font-family: $primary-font;
    font-weight: 900;
    text-transform: uppercase;
    text-align: center;
  }

  &:hover {
    text-decoration: none;
    background-color: #fff;
    box-shadow: $hover-shadow;
    opacity: 0.8;
  }

  &:hover &__illustration {
    transform: scale(1.1);
  }
}

@media (min-width: 900px) {
  .UniverseCard {
    font-size: 1.25rem;

    &__title {
      font-size: 1.25rem;
    }
  }
}
</style>
